
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 33.4 33.54"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('rect',{staticClass:"cls-1",attrs:{"x":"1.5","y":"1.5","width":"11.82","height":"11.88","rx":"1.8"}}),_c('rect',{staticClass:"cls-1",attrs:{"x":"20.07","y":"1.5","width":"11.82","height":"11.88","rx":"1.8"}}),_c('rect',{staticClass:"cls-1",attrs:{"x":"1.5","y":"20.16","width":"11.82","height":"11.88","rx":"1.8"}}),_c('rect',{staticClass:"cls-1",attrs:{"x":"20.07","y":"20.16","width":"11.82","height":"11.88","rx":"1.8"}})])
          )
        }
      }
    